let faqsQ = document.getElementsByClassName('glossary-pagination__filters');

for (let i = 0; i < faqsQ.length; i++) {
    let ptag = faqsQ[0].getElementsByClassName('text');
    let filters = faqsQ[0].getElementsByClassName('filters');

    ptag[0].addEventListener('click', function() {
        if (faqsQ[0].classList.contains('open')) {
            faqsQ[i].classList.remove('open');
            filters[0].style.none;
        } else {
            faqsQ[i].classList.add('open');
            filters[i].style.block;
        }
    })
}